import { BoomKeys } from '../modules/boom/constants/storage';
export const MUTE_LOCAL_STORAGE_NAME = 'application:prefs:mute';
export const REDIRECT_KOHLANTA_2023 = 'application:betting:redirect:kl:2023';

const UserOptionsKeys = Object.freeze({
  USER_OPTIONS_DISPLAY_BET_SLIDERS_BY_DEFAULT: 'application:betting:user-opt:bet-sliders-by-default',
});

const HistoryKeys = Object.freeze({
  USER_PREFS_COMPACT_HISTORY: 'application:prefs:compact-history',
  HAS_COMPACT_HISTORY_SWITCH_TOOLTIP_BEEN_VIEWED: 'application:betting:history:compactSwitchTooltipViewed',
  HAS_MORE_BUTTON_BEEN_VIEWED: 'application:betting:history:moreButtonViewed',
});

const ShareKeys = Object.freeze({
  USER_PREFS_SHARE_NICKNAME: 'application:prefs:share-nickname',
  USER_PREFS_SHARE_STACK: 'application:prefs:share-stack',
});

const LineUpKeys = Object.freeze({
  HAS_LINE_UP_TOOLTIP_BEEN_VIEWED: 'application:betting:lineup:lineupTooltipViewed',
});

const MyMatchKeys = Object.freeze({
  HAS_MY_MATCH_SWITCH_TOOLTIP_BEEN_VIEWED: 'application:betting:mymatch:mmSwitchTooltipViewed',
});

const MatchToolBarKeys = Object.freeze({
  HAS_EVENT_CENTER_TOOLTIP_BEEN_VIEWED: 'application:betting:matchToolbar:eventCenterTooltipViewed',
});

export const StorageKeys = Object.freeze({
  ...UserOptionsKeys,
  ...HistoryKeys,
  ...ShareKeys,
  ...LineUpKeys,
  ...MyMatchKeys,
  ...BoomKeys,
  ...MatchToolBarKeys,
});
